import { render, staticRenderFns } from "./top-section.vue?vue&type=template&id=0c869a4b&scoped=true"
import script from "./top-section.vue?vue&type=script&lang=js"
export * from "./top-section.vue?vue&type=script&lang=js"
import style0 from "./top-section.vue?vue&type=style&index=0&id=0c869a4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c869a4b",
  null
  
)

export default component.exports